import React, {createRef} from "react";
import "assets/img/Logo.png"
import "./home.scss"

import Hero from "./Home/Hero"
import NavBar from "./Home/NavBar"
import MeetTheTeam from "./Home/MeetTheTeam"
import Sponsors from "./Home/Sponsors"
import Summary from "./Home/Summary"
import System from "./Home/System"
import Museum from "./Home/Museum"

class Home extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.hero = createRef()
		this.sponsors = createRef()
		this.summary = createRef()
		this.team = createRef()
		this.museum = createRef()
		this.system = createRef()
	}

	render() {
		// document.body.classList.remove("white-content");
		const refList = {
			hero: this.hero,
			summary: this.summary,
			sponsors: this.sponsors,
			team: this.team,
		}
		return (
			<div className="home_">
				{/* <div className="headder">
					<NavBar refList={refList}/>
				</div> */}
				<Hero refs={this.hero}/>

				<div className="body">
					<Summary refs={this.summary}/>
					<MeetTheTeam refs={this.team}/>
					<Museum refs={this.museum}/>
					<System refs={this.system}/>
					
					<Sponsors refs={this.sponsors}/>
				</div>
			</div>
		);
	}
}
export default Home;
